module.exports = __webpack_public_path__ + "static/media/icon-man.f6150762.svg";